import { loginIcon } from "@/assets/icons/icons";
import { RootState, useAppSelector } from "@/utils/storage/stores/store";
import { useEffect, useRef } from "react";
import styles from './LoginSlideDownMenu.module.scss';
import { cn } from '@/utils/cn.ts';
import { Link } from "react-router-dom";
import jsCookie from "js-cookie";
import { DOMAIN } from "@/config.tsx";

interface Props {
    isOpen: boolean,
    close: () => void,
}

/** Выпадающее меню при клике на кнопку логина */
export const LoginSlideDownMenu: React.FC<Props> = ({ isOpen, close }) => {
    const username = useAppSelector((state: RootState) => state.user.userInfo?.username || '');
    const menu = useAppSelector((state: RootState) => state.user.userInfo?.menu || []);
    const containerRef = useRef<HTMLDivElement>(null);

    /** Добавление слушателя на клик вне контейнера и закрытие меню */
    useEffect(() => {
        let timer: NodeJS.Timeout;

        /** Обработчик клика вне контейнера */
        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && event.target !== containerRef.current) {
                close();
            }
        };

        if (isOpen) {
            setTimeout(() => { document.addEventListener('click', handleClickOutside) });
        } else {
            document.removeEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
            clearTimeout(timer);
        };
    }, [isOpen]);

    /** Выход из аккаунта */
    const logout = () => {
        if (typeof window !== 'undefined') {
            jsCookie.remove('user', { path: '/', domain: DOMAIN });
            // window.location.href = '/';
        }
    };

    return (
        <div ref={containerRef} className={cn(styles.container, isOpen && styles.open)}>
            <div>
                <img src={loginIcon} alt='Логин' />
                <p>{username}</p>
            </div>
            <ul>
                {menu.map((item, index) => <li key={`slide-down-menu-item-${index}`}>
                    <Link to={item.link}>{item.name}</Link>
                </li>)}
                <li><button onClick={logout}>Выйти</button></li>
            </ul>
        </div>
    );
};

export default LoginSlideDownMenu;
